module.exports = __webpack_public_path__ + "img/image42.af103d68.webp";